import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import { NavLink } from "react-router-dom";
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { SubmitButton, TextBox } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, decodeData } from "../../Constants/constants";


class AssignRM extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      employee_id: 0,
      reporting_manager: '1',
      location_id: "",
      department_id: "",
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      loadingPost: false,
      get_location_row: [],
      department_row: [],
      selectedEmployeeId: null,
      selectedRows: [],
      agency_verification_status: '',
      empOptions: [],
      emp_keyword: '',
      selected_rm_employee_id: '',
      reporting_manager_employee_id: '',
      loadingFilter: false,
      loadingSearch: false,
      decodedData: [],
      allEmpOptions: [],
      want_to_notify: "0",
      other_employee_ids: "",
      notify_for_actions: "",
      errors: {},
      otherNotifyEmployeesModal: false,
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetDepartmentMasters();
      // this.GetEmployeesOptionList();
      this.getAllEmployeesOptionList();
      this.GetLocationMasters();
      this.GetList();
      this.GetLocationList();
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }
  
  GetEmployeesOptionList = () => {
    if (this.state.emp_keyword) {
      const { apiURL, apiHeaderJSON } = this.context;
      const headers = apiHeaderJSON;
      try {
        axios
          .get(`${apiURL}Employees/GetEmployeesOptionList`, { params: { keyword: this.state.emp_keyword }, headers })
          .then((response) => {
            if (response.data.success === true) {
              this.setState({ empOptions: response.data.data })
            } else {
              this.setState({ empOptions: [] })
            }
          })
      } catch (error) {
        console.log("error", error)
      }
    } else {
      console.log("no emp keyword")
    }
  }

  getAllEmployeesOptionList = (e) => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    try {
      axios
        .get(`${apiURL}Masters/GetCompanyEmployeesList`, { params: { keyword: '' }, headers })
        .then((response) => {
          if (response.data.success === true) {
            this.setState({ allEmpOptions: response.data.data });
            console.log("GetCompanyEmployeesList =>",response.data.data);
          } else {
            this.setState({allEmpOptions:[]});
          }
        })
    } catch (error) {
      console.error("error", error)
    }
}

  handleMultiSelect = (fieldName, selectedOptions) => {
    console.log("selectedOptions",selectedOptions);
    const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
    this.setState((prevState) => ({
      [fieldName]: ids.join(','),
      errors: {
        ...prevState.errors,
        [fieldName]: '',
      },
    }));
  };
  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));

  };


  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            department_row: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };
  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetEmployeesByRM`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          department_id: this.state.department_id,
          location_id: this.state.location_id,
          reporting_manager_employee_id: this.state.reporting_manager_employee_id,
        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next,
            prev: data.prev,
            page: data.page,
            total_records: data.total_records,
            total_pages: data.total_pages,
            loadingList: false,
            loadingFilter: false,
            loadingSearch: false,
          });
        } else {
          this.setState({ loadingList: false ,
            loadingFilter: false,
            loadingSearch: false, });
        }
      });
  };

  handleSubmit = () => {
    const errors = this.validateForm();
    console.log("errors", errors);
    if (Object.keys(errors).length > 0) {
        this.setState({ errors,loadingPost:false });
        return;
    }

    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    if (!this.state.selected_rm_employee_id) {
      return false;
    }
    const formData = {
      employee_id: this.state.selectedRows,
      reporting_manager_employee_id: this.state.selected_rm_employee_id,
      add_other: this.state.want_to_notify==="1"? "1":null, 
      other_employee_ids: this.state.other_employee_ids, 
      notify_for_actions: this.state.notify_for_actions, 
      date: currentDateAndTime(),
    };
    console.log("AssignRM => formData =>",formData);
    axios.post(`${apiURL}Employees/AssignRM`, formData, { headers })
    .then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          loadingList: true, 
          assignModal:false, 
          loadingPost:false, 
          selected_rm_employee_id: '',
          want_to_notify: "0",
          other_employee_ids: "",
          notify_for_actions: "",
          selectedRows: [] }, 
          (prevState) => {
          this.GetList();
        })
      } else {
        this.setState({ loadingPost:false, })
      }
      Swal.fire({
      title: `<strong>${response.data.success === true ? "Success" : "Failed"}</strong>`,
      text: response.data.message,
      icon: response.data.success === true ? "success" : "error",
      showConfirmButton: true,
      allowOutsideClick: false,
      });
    })
    .catch((error)=>{
      this.setState({ loadingPost:false, });
      Swal.fire({
          title: `<strong>Failed}</strong>`,
          text: "Opps...! Something went wrong.",
          icon: "error",
          showConfirmButton: true,
          allowOutsideClick: false,
      });
    })
  };

  validateForm() {
    const errors = {};

    if (this.state.want_to_notify==="1" && !this.state.other_employee_ids) {
        errors.other_employee_ids = 'Please select employees!';
    }
    if (this.state.want_to_notify==="1" && !this.state.notify_for_actions) {
        errors.notify_for_actions = 'This is required!';
    }
    return errors;
  }

  handleInputSearch = (e) => {
    this.GetList();
    //   this.GetLocationList();
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  };


  handleCheckboxChange = (row) => {
    this.setState((prevState) => {
      const selectedRows = [...prevState.selectedRows];

      if (selectedRows.includes(row?.employee_id)) {
        selectedRows.splice(selectedRows.indexOf(row?.employee_id), 1);
      } else {
        selectedRows.push(row?.employee_id);
      }

      return { selectedRows };
    },()=>{
        if(this.state.selectedRows.length===1){
            this.setState({ 
              selected_rm_employee_id: row?.reporting_manager_id,
              want_to_notify: row?.notify_for_actions? "1" : "0",
              other_employee_ids: row?.other_notify_employee_ids,
              notify_for_actions: row?.notify_for_actions,

            })
        }
        else{
            this.state.selected_rm_employee_id &&  this.setState({
              selected_rm_employee_id: "",
              want_to_notify: "0",
              other_employee_ids: "",
              notify_for_actions: "",
            })
        }
    });
  };

  handleSelectAll = () => {
    this.setState((prevState) => {
      const selectedRows = prevState.selectedRows.length === prevState.rows.length
        ? []
        : prevState.rows.map((row) => row.employee_id);

      return { selectedRows };
    });
  };

  handleSelectAllDropdown = (action) => {
    if (action === 'select-all') {
      this.setState({ selectedRows: this.state.rows.map((row) => row.employee_id) });
    } else if (action === 'deselect-all') {
      this.setState({ selectedRows: [] });
    }
  };

  GetLocationList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetLocationList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            get_location_row: data.data.map((row) => ({
              value: row.location_id,
              label: row.location_title
            }))
          }));
        }
      });
  }

  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();
          this.GetLocationList();
        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();
          this.GetLocationList();
        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
        this.GetLocationList();
      }
    );
  };

  handleSelectChange = (name, selectedOption) => {

    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1, // Reset to first page
      },
      () => {
        this.GetList();
      }
    );
  };
  

  handleClearAll = () => {
    this.setState(
      {
        location_id: '',
        department_id: '',
        location_shift_id: '',
        reporting_manager_employee_id: '',
        keyword: "",
        rows: [],
        next: false,
        prev: false,
        page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
        loadingList: false,
        postLoading: false,
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const {errors} = this.state;
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const actions_options=[
      {value:"1", label:"Regularization"},
      {value:"2", label:"Leave"},
    ]

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Assign RM`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="keyword">Search By Name</label>
                        <div className="input-group">
                          <input
                            type="search"
                            className="form-control"
                            onChange={this.handleInputChange}
                            name="keyword"
                            value={this.state.keyword}
                            aria-label="Recipient's username"
                            aria-describedby="button-addon2"
                            placeholder="Search Name"
                          />
                          <button
                            className="btn btn-success"
                            disabled={this.state.loadingSearch}
                            onClick={() => {
                              if (
                                this.state.keyword &&
                                !this.state.loadingSearch
                              ) {
                                this.handleInputSearch();
                              }
                            }}
                            type="button"
                            id="button-addon2"
                          >
                            {this.state.loadingSearch ? (
                              <span
                                class="spinner-border flex-shrink-0"
                                role="status"
                                style={{
                                  width: "0.8rem",
                                  height: "0.8rem",
                                  borderWidth: "2px",
                                }}
                              >
                                <span class="visually-hidden">Loading...</span>
                              </span>
                            ) : (
                              <i className="ri-search-line"></i>
                            )}
                          </button>
                        </div>
                      </div>
                      {/* <div className="col-md-3 ">
                        <label htmlFor="Employee" className="form-label" > Search & Select Reporting Manager </label>
                        <Select
                          onInputChange={(e) => this.setState({ emp_keyword: e }, () => { this.GetEmployeesOptionList() })}
                          options={this.state.empOptions}
                          onChange = {(selectedOption) => this.handleSelectChange('reporting_manager_employee_id', selectedOption)}
                          placeholder={`Enter Reporting Manager Code Or Name`}
                        />
                      </div> */}
                      {/* search employees under selected reporting manager */}
                      {/* <div className='col-md-3'>
                        <div>
                          <label>Search & Select Reporting Manager</label>
                        </div>
                        <Select
                          options = {this.state.empOptions}
                          value = {this.state.reporting_manager_employee_id ? this.state.empOptions.find(option => option.value === this.state.reporting_manager_employee_id) : null}
                          onChange = {(selectedOption) => this.handleSelectChange('reporting_manager_employee_id', selectedOption)}
                          placeholder={`Select Reporting Manager`}
                        />
                      </div> */}
                      {/* search employees under selected reporting manager */}

                      <div className='col-md-3'>
                        <div>
                          <label>Check Location</label>
                        </div>
                        <Select
                          options={this.state.get_location_row}
                          value={this.state.location_id ? this.state.get_location_row.find(option => option.value === this.state.location_id) : null}
                          onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                          placeholder={`Select Location`}
                        />

                      </div>
                      <div className='col-md-3'>
                        <div>
                          <label>Check Department</label>
                        </div>
                        <Select
                          onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                          placeholder={`Select Department`}
                          options={this.state.department_row}
                          value={this.state.department_id ? this.state.department_row.find((option) => option.value === this.state.department_id) : null}
                        />
                      </div>
                      
                         
                          <div style={{ width: "11%" }} className="col-md-2">
                      <div>
                        <label>Apply Filter</label>
                      </div>
                      {this.state.loadingFilter === "1" ? (
                        <button className="btn btn-info btn-load">
                          <span className="d-flex align-items-center">
                            <span
                              className="spinner-border flex-shrink-0"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </span>
                            <span className="flex-grow-1 ms-2">Loading...</span>
                          </span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => {
                            this.setState(
                              {
                                loadingFilter: "1",
                              },
                              () => {
                                this.handleInputSearch();
                                console.log(
                                  "this.state.loadingFilter1 ==>",
                                  this.state.loadingFilter
                                );
                              }
                            );

                            // console.log("this.state.loadingFilter ==>" + this.state.loadingFilter);
                          }}
                          className={`w-100 btn btn-info btn-label waves-effect waves-light ${
                            !this.state.keyword &&
                            this.state.from_date === "" &&
                            this.state.to_date === "" &&
                            this.state.selectOption === "" &&
                            !this.state.filter_leave_type_id
                              ? "disabled"
                              : ""
                          }`}
                        >
                          <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                          Filter
                        </button>
                      )}
                    </div>
                    <div style={{ width: "11%" }} className="col-md-3">
                      <div>
                        <label>Clear Filter</label>
                      </div>
                      {this.state.loadingFilter === "2" ? (
                        <button className="btn btn-secondary btn-load">
                          <span className="d-flex align-items-center">
                            <span
                              className="spinner-border flex-shrink-0"
                              role="status"
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </span>
                            <span className="flex-grow-1 ms-2">Loading...</span>
                          </span>
                        </button>
                      ) : (
                        <button
                          type="button"
                          className={`btn w-100 noWrap btn-secondary btn-label waves-effect waves-light ${
                            !this.state.keyword &&
                            this.state.from_date === "" &&
                            this.state.selectOption === "" &&
                            this.state.to_date === "" &&
                            !this.state.filter_leave_type_id
                              ? "disabled"
                              : ""
                          }`}
                          onClick={() => {
                            this.setState({ loadingFilter: "2" }, () => {
                              this.handleClearAll();
                              console.log(
                                "this.state.loadingFilter1 ==>",
                                this.state.loadingFilter
                              );
                            });
                          }}
                        >
                          <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2 noWrap"></i>{" "}
                          Clear
                        </button>
                      )}
                    </div>
                    { this.state.decodedData?.includes(3) && (  
                    <div className='col-md-3'>
                      <div>
                        <label>Assign RM</label>
                      </div>
                      <button
                        onClick={()=>{ this.setState({ assignModal:true }) }}
                        type="button"
                        className={`btn noWrap btn-success btn-label waves-effect right waves-light ${(this.state.selectedRows.length === 0) ? 'disabled' : ''}`}>
                        <i className="ri-user-settings-line label-icon align-middle fs-16 ms-2" />
                        Assign RM
                      </button>
                    </div>)}
                      
                    </div>
                  </div>
                  <div className="card-body">
                    <table className={`table table-bordered table-hover`}>
                      <thead className="table-light">
                        <tr>
                        { this.state.decodedData?.includes(3) && (  
                          <th>
                            <div className="btn-group" style={{ background: "rgb(221 224 227)" }}>
                              <button type="button" className="btn">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  checked={this.state.selectedRows.length === this.state.rows.length}
                                  onChange={this.handleSelectAll}
                                />
                              </button>
                              <button
                                type="button"
                                className="btn dropdown-toggle dropdown-toggle-split"
                                id="dropdownMenuReference"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                data-bs-reference="parent"
                                style={{ background: "#c7c7c7" }}
                              >
                                <span className="visually-hidden">Toggle Dropdown</span>
                              </button>
                              <ul className="dropdown-menu" aria-labelledby="dropdownMenuReference">
                                <li>
                                  <button className="dropdown-item" onClick={() => this.handleSelectAllDropdown('select-all')}>
                                    Select All
                                  </button>
                                </li>
                                <li>
                                  <button className="dropdown-item" onClick={() => this.handleSelectAllDropdown('deselect-all')}>
                                    Deselect All
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </th>)}
                          <th>Employee Code</th>
                          <th>Employee Name</th>
                          <th>Employee Mobile Number</th>
                          <th>Employee Email Address</th>
                          <th>RM</th>
                          <th>Notify To</th>


                        </tr>
                      </thead>
                      {this.state.rows.length === 0 ? (
                        <tbody>
                          <tr>
                            <td colSpan={11}>
                              <NoRecords />
                            </td>
                          </tr>
                        </tbody>
                      ) :
                        <tbody>
                          {this.state.rows.map((row) => {
                            return (
                              <tr key={row.employee_id}>
                                { this.state.decodedData?.includes(3) && (  
                                <td >
                                  <div className="d-flex justify-content-center align-items-center">
                                    <input type="checkbox" className="form-check-input" checked={this.state.selectedRows.includes(row.employee_id)} onChange={() => this.handleCheckboxChange(row)} />
                                  </div>
                                </td>)}
                                <td>{row.employee_code}</td>
                                <td>
                                  {/* <NavLink to={`/Profile/${row.employee_id}`}> */}
                                    {row.employee_name}
                                  {/* </NavLink> */}
                                </td>
                                <td>{row.employee_mobile_number}</td>
                                <td>{row.employee_official_email}</td>
                                <td>{row.reporting_manager_name}</td>
                                <td className=" text-center">
                                  {Array.isArray(row?.other_notify_employee) && row?.other_notify_employee?.length>0 ? 
                                  <span onClick={()=> this.setState({ otherNotifyEmployeesModal: row?.other_notify_employee })} className={`btn btn-success py-1 px-2 cursorPointer`} >
                                    View
                                  </span>:
                                  <span className={`badge bg-info`}>
                                    UnAssign
                                  </span>
                                  }
                                  
                                </td>

                              </tr>
                            );
                          })}
                        </tbody>}
                      <tfoot className="table-light">
                        <tr>
                          <th colSpan={8}>
                            <div className="d-flex justify-content-between">
                              <button
                                disabled={
                                  this.state.prev === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handlePrev()}
                                className={`btn btn-warning btn-label waves-effect waves-light`}
                              >
                                <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                Previous
                              </button>
                              <div
                                className="col-md-4"
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                {
                                  <small>
                                    Total Records: {this.state.total_records} |
                                    Total Pages: {this.state.total_pages} |
                                    Current Page: {this.state.page}
                                  </small>
                                }
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={(e) => this.handleChange(e)}
                                >
                                  {Array.from(
                                    { length: this.state.total_pages },
                                    (_, i) => (
                                      <option
                                        selected={this.state.page === i + 1}
                                        key={i}
                                        value={i + 1}
                                      >
                                        Page {i + 1}
                                      </option>
                                    )
                                  )}
                                </select>
                              </div>
                              <div className="col-md-2">
                                <select
                                  className="form-select"
                                  onChange={this.handleLimitChange}
                                  value={this.state.limit}
                                >
                                  <option value={this.state.total_records}>
                                    All
                                  </option>
                                  {limitOptions.map((option) => (
                                    <option key={option} value={option}>
                                      Limit {option}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <button
                                disabled={
                                  this.state.next === false &&
                                    this.state.loadingList === false
                                    ? true
                                    : false
                                }
                                type="button"
                                onClick={() => this.handleNext()}
                                className={`btn btn-primary btn-label waves-effect right waves-light`}
                              >
                                <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                Next
                              </button>
                            </div>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
                {/* assign rm modal  */}
                {this.state.assignModal && (
                  <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                   tabIndex={-1} aria-labelledby="rmModalLabel" aria-hidden="true">
                  <div className=" d-flex align-items-center m-auto h-100"
                  style={{ width: "40%" }}>
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="rmModalLabel">Reporting Managers</h5>
                        <button type="button" disabled={ this.state.loadingPost } onClick={()=>{if(!this.state.loadingPost) this.setState({assignModal:false,}); }} className="btn-close" aria-label="Close"/>
                      </div>
                      <div className="modal-body">
                        <div className="col-md-12 ">
                          <label htmlFor="Employee" className="form-label" > Search & Select Reporting Manager </label>
                          {/* <Select
                            onInputChange={(e) => this.setState({ emp_keyword: e }, () => { this.GetEmployeesOptionList() })}
                            options={this.state.empOptions}
                            onChange={(e) => this.setState({ selected_rm_employee_id: e.value })}
                            placeholder={`Enter Employee Code Or Name`}
                          /> */}
                          <Select 
                            onChange={(selectedOptions) =>  this.setState({ selected_rm_employee_id: selectedOptions?.value })}
                            placeholder={"Search Employee Code Or Name"}                            
                            options={this.state.allEmpOptions}
                            value={this.state.selected_rm_employee_id ? this.state.allEmpOptions.find(option => option.value == this.state.selected_rm_employee_id) : null}
                            />
                        </div>
                        <div className="col-md-12 ">
                          <div class="col-md-12 mt-3 settings-section">
                            <div class="form-check form-check-inline mt-2">
                              <input
                                type="radio"
                                id="reporting_manager1"
                                name="reporting_manager1"
                                value="1"
                                checked={this.state.reporting_manager === '1'}
                                onChange={() => this.handleRadioChange('reporting_manager', '1')}
                                class="form-check-input"
                              />
                              <label for="reporting_manager1" class="form-check-label">RM Level1</label>
                            </div>
                            {/* <div class="form-check form-check-inline">
                              <input
                                type="radio"
                                id="reporting_manager2"
                                name="reporting_manager2"
                                value="0"
                                checked={this.state.reporting_manager === '2'}
                                onChange={() => this.handleRadioChange('reporting_manager', '2')}
                                class="form-check-input"
                              />
                              <label for="reporting_manager2" class="form-check-label">RM Level2</label>
                            </div> */}
                          </div>
                        </div>
                        <div class="col-md-12 mt-3">
                            <div>
                                <label for="want_to_notify" class="form-label">Do you want to notify other than RM.
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                    type="radio"
                                    id="want_to_notify1"
                                    name="want_to_notify"
                                    value='1'
                                    checked={this.state.want_to_notify == '1'}
                                    onChange={() => this.handleRadioChange('want_to_notify', '1')}
                                    class="form-check-input"
    
                                />
                                <label for="want_to_notify1" class="form-check-label">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input
                                    type="radio"
                                    id="want_to_notify0"
                                    name="want_to_notify"
                                    value="0"
                                    checked={this.state.want_to_notify == '0'}
                                    onChange={() => this.handleRadioChange('want_to_notify', '0')}
                                    class="form-check-input"
  
                                />
                                <label for="want_to_notify0" class="form-check-label">No</label>
                            </div>
                        </div>
                        {this.state.want_to_notify==="1" && (
                          <>
                          <div className="col-md-12 mt-3">
                            <label>Whom to notify?</label>
                            <Select 
                            onChange={(selectedOptions) => this.handleMultiSelect("other_employee_ids", selectedOptions)}
                            placeholder={"Search & Select Employees"}
                            isMulti
                            options={this.state.allEmpOptions}
                            value={this.state.other_employee_ids ? this.state.other_employee_ids.split(',').map(id => this.state.allEmpOptions.find(option => option.value == id)) : null}
                            />
                            {errors?.other_employee_ids  ?<div className=" text-danger">{errors?.other_employee_ids }</div>: null}
                          </div>
                          <div className="col-md-12 mt-3">
                            <label>When to notify?</label>
                            <Select 
                            onChange={(selectedOptions) => this.handleMultiSelect("notify_for_actions", selectedOptions)}
                            placeholder={"Select"}
                            isMulti
                            options={actions_options}
                            value={this.state.notify_for_actions ? this.state.notify_for_actions.split(',').map(id => actions_options.find(option => option.value == id)) : null}
                            />
                            {errors?.notify_for_actions  ?<div className=" text-danger">{errors?.notify_for_actions }</div>: null}
                          </div>
                          </>
                        )}
                        
                      </div>
                      <div className="modal-footer">
                        <button type="button" disabled={ this.state.loadingPost } 
                        onClick={()=>{ if(!this.state.loadingPost){  
                          this.setState({assignModal:false,});} }} className="btn btn-light">Close</button>
                        <SubmitButton onClick={(e)=>{
                          if(!this.state.loadingPost){
                            this.setState({loadingPost:true},()=> this.handleSubmit())
                          }}}
                        disabled={!this.state.selected_rm_employee_id}
                        loading={this.state.loadingPost}
                        loadingMessage='Loading' buttonName={'Assign'} icon={'ri-file-excel-line'} 
                        type='success' iconSide='left' />
                      </div>
                    </div>
                  </div>
                  </div>
                )}
                
                {/* view assigned other employee  */}
                {this.state.otherNotifyEmployeesModal && (
                  <div className="modal show" tabIndex={-1}
                      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)",}}
                      aria-labelledby="myModalLabel"
                      aria-hidden="true">
                  <div className=" d-flex align-items-center justify-content-center m-auto h-100"
                          style={{ width: "40%" }}>
                      <div className="modal-content mb-3">
                      <div className="modal-header">
                          <h5 className="modal-title">Other Employees to notify</h5>
                          <button
                          type="button"
                          onClick={()=>{
                            this.setState({otherNotifyEmployeesModal:false,});
                          }}
                          className="btn-close"
                          aria-label="Close"
                          />
                      </div>
                      <div className="modal-body py-0">
                          <form>
                          <div className="mb-3">
                              <label>Employees:</label>
                              <div className=" d-flex gap-2 align-items-center">
                                {this.state.otherNotifyEmployeesModal?.map((val)=>{
                                  return(
                                    <span className={`btn bg-light text-dark`}>
                                      {val}
                                    </span>
                                  )
                                })}
                                
                              </div>
                          </div>
                          </form>
                      </div>
                      </div>
                  </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AssignRM);
